import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { rsvp } from '../api';
import { useAuth, withAuth } from '../context/AuthContext';
import { useAudio } from '../context/AudioManagementContext';
import RSVP from '../component/RSVP';
import Modal from '../component/Modal';
import SpecialButton from '../component/SpecialButton';
import FlyingFish from '../component/FlyingFish';
import BackgroundMusic from '../component/BackgroundMusic';
import music from '../asset/sound/home.mp3';

function Invitation() {
  const { guestId, status } = useAuth();
  const storedClick = window.localStorage.getItem('click');

  const [showRSVP, setShowRSVP] = useState(false);
  const [showFlyer, setShowFlyer] = useState(false);
  const [closingFlyer, setClosingFlyer] = useState(false);
  const [showSign, setShowSign] = useState(false);
  const [attending, setAttending] = useState(undefined);
  const [click, setClick] = useState(storedClick ? Number(storedClick) : 0);
  const [clubMusic, setClubMusic] = useState(undefined);
  const { playClub } = useAudio();

  const incrementClick = (value) => {
    if (click < value) {
      setClick(value);
      window.localStorage.setItem('click', value);
    }
  };

  useEffect(() => {
    if (attending === undefined && status && status.attending) {
      setShowRSVP(false);
      setAttending(Object.values(status.attending).includes(true));
      if (click < 1) {
        setClick(1);
        window.localStorage.setItem('click', 1);
      }
    }
  }, [status, attending, setAttending, click, setClick, setShowRSVP]);

  const navigate = useNavigate();

  const closeRSVP = () => {
    setShowRSVP(false);
  };

  const closeSign = () => {
    setShowSign(false);
  };

  const closeFlyer = () => {
    setClosingFlyer(true);
    setTimeout(() => {
      setShowFlyer(false);
      setClosingFlyer(false);
    }, 830);
  };

  const submitRSVP = (form, callback) => {
    setAttending(Object.values(form.attending).includes(true));
    rsvp(guestId, form.email, form.attending, form.message, () => {
      incrementClick(1);
      closeRSVP();
      callback();
    });
  };

  let rsvpButton = (
    <SpecialButton name="egg-blue" onClick={() => setShowRSVP(true)} />
  );

  if (attending === true) {
    rsvpButton = (
      <SpecialButton
        name="egg-blue-happy"
        hasText
        onClick={() => setShowRSVP(true)}
      />
    );
  }

  if (attending === false) {
    rsvpButton = (
      <SpecialButton name="egg-blue-sad" onClick={() => setShowRSVP(true)} />
    );
  }

  const navigateToRegistry = () => {
    incrementClick(3);
    clubMusic && clubMusic.stop();
    navigate('/registry');
  };

  const navigateToAttire = () => {
    incrementClick(6);
    clubMusic && clubMusic.stop();
    navigate('/attire');
  };

  return (
    <div className="page invitation">
      <FlyingFish />
      <FlyingFish />
      <div className="tree-background">
        <img
          src={require('../asset/img/tree-invitation.png')}
          alt="tree"
          className="tree"
        />
        {click >= 1 && (
          <SpecialButton
            name="worm"
            hasText
            onClick={() => incrementClick(2)}
          />
        )}
        {click >= 4 && (
          <SpecialButton
            name="pony"
            hasText
            onClick={() => {
              incrementClick(5);
              clubMusic && clubMusic.stop();
              playClub(0.5, setClubMusic);
            }}
          />
        )}
        {click >= 7 && <SpecialButton name="chicken" hasText />}
        <SpecialButton
          name="tree-flyer"
          onClick={() => {
            setShowFlyer(true);
            clubMusic && clubMusic.stop();
          }}
        />
        <SpecialButton name="sign" onClick={() => setShowSign(true)} />
        {click >= 2 && (
          <SpecialButton name="registry" onClick={navigateToRegistry} />
        )}
        {click >= 5 && (
          <SpecialButton name="attire" onClick={navigateToAttire} />
        )}
        {click >= 3 && (
          <SpecialButton
            name="dino"
            hasText
            onClick={() => incrementClick(4)}
          />
        )}
        {click >= 6 && (
          <SpecialButton
            name="walrus"
            hasText
            onClick={() => incrementClick(7)}
          />
        )}
        {rsvpButton}
        <RSVP show={showRSVP} onClose={closeRSVP} onSubmit={submitRSVP} />
        <Modal show={showSign} onClose={closeSign}>
          <div className="sign-modal">
            <h1>WHERE</h1>
            <h2>101 BELLEVUE STREET</h2>
            <h2>NEWTON MA, 02458</h2>
            <h1>WHEN</h1>
            <h2>SATURDAY JULY 19th, 2025</h2>
            <h2>3:30pm</h2>
          </div>
        </Modal>
        <Modal show={showFlyer} onClose={closeFlyer} className="flyer">
          <img
            src={require(
              `../asset/img/${closingFlyer ? 'flyer-animation' : 'flyer'}.png`
            )}
            alt="flyer"
            className="pixel-corners"
          />
          <BackgroundMusic music={music} volume={1} fade={closingFlyer} />
        </Modal>
      </div>
      {click >= 1 && <FlyingFish />}
    </div>
  );
}

export default withAuth(Invitation);
